<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="M11.552.901a.5.5 0 0 1 .896 0l2.977 5.992a.5.5 0 0 0 .374.272l6.618.98a.5.5 0 0 1 .277.851l-4.778 4.683a.5.5 0 0 0-.143.44l1.113 6.597a.5.5 0 0 1-.725.526l-5.93-3.097a.5.5 0 0 0-.463 0l-5.93 3.097a.5.5 0 0 1-.724-.526l1.113-6.597a.5.5 0 0 0-.143-.44L1.306 8.996a.5.5 0 0 1 .277-.852l6.618-.98a.5.5 0 0 0 .374-.271L11.552.9Z"
  />
</svg>
